import React from "react";
import Image from "../../../Elements/Image/Image.tsx";
import Icon from "components/Elements/Icon/Icon.tsx";
import { useContent } from "../../../../contexts/contentContext/contentContext.js";
import LoadingContainerElement from "components/Elements/LoadingContainerElement/LoadingContainerElement.js";
import { useMail } from "contexts/mailContext/mailContext.js";

const NoFilesComponent = ({ searchString }) => {
  const { getTextByKey, getHtmlByKey } = useContent();
  const { getFilesLoading } = useMail();

  return getFilesLoading() ? (
    <LoadingContainerElement />
  ) : (
    <div
      className={"no-files-message" + (searchString ? "" : " no-files-folder")}
    >
      {searchString && (
        <>
          <Image name="no-match-search" ext="png" />
          {getHtmlByKey("search-no-files")}
        </>
      )}

      {/* {searchString ? (
        <Image name="no-match-search" ext="png" />
      ) : (
        <Icon name="folders" gray />
      )}
      {searchString
        ? getHtmlByKey("search-no-files")
        : getTextByKey("no-files-message")} */}
    </div>
  );
};

export default NoFilesComponent;
